import { twMerge } from "tailwind-merge";

import { getCookie, setCookie } from "cookies-next";
import { v4 as uuidv4 } from "uuid";
import isMobile from "ismobilejs";
import { getUTMParams } from "./utmParams";

export function cn(
  ...classes: (string | boolean | undefined | null)[]
): string {
  return twMerge(classes.filter(Boolean).join(" "));
}

export function getCookieValue(cookie: string, key: string) {
  if (!cookie?.includes(`${key}=`)) return;
  let retValue;
  const cookies = cookie.split(";");
  cookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split("=");
    if (name === key) {
      retValue = value;
    }
  });
  return retValue;
}

export const getTrackerId = () => {
  const trackerid = getCookie("trackerid");
  if (typeof trackerid === "string" && trackerid) {
    return trackerid;
  } else if (!trackerid) {
    const newTrackerId = uuidv4();
    setCookie("trackerid", newTrackerId, {
      path: "/",
      domain: ".ackodrive.com",
      secure: true,
      sameSite: "lax",
      maxAge: 365 * 24 * 60 * 60,
    });
    return newTrackerId;
  }
  return "";
};

export const getPageReferrer = (): string => {
  if (typeof window !== "undefined") {
    return sessionStorage.getItem("pageReferrer") || "";
  }
  return "";
};

export const getExternalReferrer = (): string => {
  if (typeof window === "undefined") {
    return "";
  }

  const referrer = document.referrer;

  // No referrer = direct visit
  if (!referrer) {
    return "";
  }

  try {
    const referrerUrl = new URL(referrer);
    const hostname = referrerUrl.hostname.toLowerCase();

    // Check if it's from internal domains
    if (hostname.includes("ackodrive.com") || hostname.includes("acko.com")) {
      return "";
    }

    // External referrer - return just the domain
    return hostname;
  } catch {
    return "";
  }
};

export const getCurrentPageType = (): string => {
  if (typeof window === "undefined") {
    return "";
  }
  return sessionStorage.getItem("currentPageType") || "";
};

export const setCurrentPageType = (pageType: string): void => {
  if (typeof window !== "undefined" && pageType) {
    sessionStorage.setItem("currentPageType", pageType);
  }
};

export const segmentEventCommonProp = () => {
  const isMobileDevice = isMobile(navigator?.userAgent).any;
  const refereshAccessToken: any = getCookie("ackodrive_tokens") || "{}";
  const isLoggedIn = Object.keys(
    JSON.parse(decodeURIComponent(refereshAccessToken))
  ).length;

  const userTrackerId = getCookie("trackerid");
  const utm = getUTMParams(true) || {};
  const leadDataString = sessionStorage.getItem("leadData");
  const ip_city = sessionStorage?.getItem("ip_city");
  const leadData = leadDataString ? JSON.parse(leadDataString) : null;

  const fullName = isLoggedIn ? leadData?.first_name : "";
  const email = isLoggedIn ? leadData?.referrer_email : "";
  const mobileNumber = isLoggedIn
    ? sessionStorage.getItem("contact_number") || ""
    : "";

  let path = "";

  if (typeof window !== "undefined") {
    path = window.location.href || "";
  }

  const queryParams =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : null;

  const pageReferrer = getPageReferrer();

  return {
    lob: "ackodrive",
    customer_name: fullName || "",
    email: email || "",
    journey: "Home Page",
    logged_in: isLoggedIn ? true : false,
    // page: path,
    // path,
    phone: mobileNumber,
    platform: !isMobileDevice ? "web" : getCookie("webview") ? "app" : "mweb",
    // referrer: source,
    tracker_id: userTrackerId,
    search: "",
    url: path,
    utm_source: utm["utm_source"] || "",
    utm_campaign: utm["utm_campaign"] || "",
    utm_content: utm["utm_content"] || "",
    utm_medium: utm["utm_medium"] || "",
    from_page: pageReferrer,
    ip_city: ip_city || "",
  };
};
